import { Form } from "react-bootstrap";
import { useState } from "react";
import BackBtn from "../../components/templates/back";
import loading from "../../assets/images/loading.svg";
import axios from "axios";
import {
  getBaseApiURL,
  console_log,
  showToast,
} from "../../utils/commonHelper";
import { useLocation, useNavigate } from "react-router-dom";

const Forgot = () => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [emailAddress, setEmailAddress] = useState("");
  const [forgotStep, setForgotStep] = useState(1);
  const [password, setPassword] = useState("");
  const [verificationCode, setVerificationCode] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const navigate = useNavigate();
  const handleInputChange = (index, value) => {
    // Allow only single numeric or alphabetical character
    if (value.length <= 1 && /^[a-zA-Z0-9]*$/.test(value)) {
      const updatedCode = [...verificationCode];
      updatedCode[index] = value;
      setVerificationCode(updatedCode);

      // Automatically move to the next input field if value is valid
      if (value && index < verificationCode.length - 1) {
        document.getElementById(`code-input-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && index > 0 && !verificationCode[index]) {
      // Move to the previous field on Backspace if current field is empty
      document.getElementById(`code-input-${index - 1}`).focus();
    }
  };

  const handlePaste = (index, e) => {
    e.preventDefault(); // Prevent default paste behavior
    const pastedData = e.clipboardData.getData("text");
    const updatedCode = [...verificationCode];

    // Distribute the pasted content across the input fields
    for (let i = 0; i < pastedData.length && i < verificationCode.length; i++) {
      updatedCode[i] = pastedData[i];
    }

    setVerificationCode(updatedCode);

    // Focus the next input field if all fields are filled
    if (pastedData.length >= verificationCode.length) {
      document
        .getElementById(`code-input-${verificationCode.length - 1}`)
        .focus();
    }
  };
  const clickedConfirmationCodeButton = async () => {
    let confirmation_code = verificationCode.join("");
    setIsDisabled(true);
    let url =
      getBaseApiURL() +
      `/auth/confirm-forgot-password?email=${encodeURIComponent(
        emailAddress
      )}&new_password=${password}&confirmation_code=${confirmation_code}`;
    await axios
      .post(
        url,
        {},
        {
          headers: {
            "Content-Type": "application/json", // Set content type
          },
        }
      )
      .then((response) => {
        let data = { email: emailAddress, password: password };
        showToast("Password Reset Successful");
        navigate("/login");
      })
      .catch((error) => {
        setIsDisabled(false);
        console_log("errror", error);
        showToast(error, "error");
      });
  };
  const clickedResendCodeButton = async () => {
    setIsDisabled(true);
    let url =
      getBaseApiURL() +
      `/auth/resend-confirmation?email=${encodeURIComponent(emailAddress)}`;
    await axios
      .post(
        url,
        {},
        {
          headers: {
            "Content-Type": "application/json", // Set content type
          },
        }
      )
      .then((response) => {
        console_log("response", response);
        showToast(response.data.message);
        setIsDisabled(false);
      })
      .catch((error) => {
        setIsDisabled(false);
        showToast(error, "error");
      });
  };
  const clickedForgotPasswordButton = async () => {
    setIsDisabled(true);
    let url =
      getBaseApiURL() +
      `/auth/forgot-password?email=${encodeURIComponent(emailAddress)}`;
    await axios
      .post(
        url,
        {},
        {
          headers: {
            "Content-Type": "application/json", // Set content type
          },
        }
      )
      .then((response) => {
        console_log("reps...", response.data);
        setIsDisabled(false);
        setForgotStep(2);
      })
      .catch((error) => {
        console_log("error", error);

        setIsDisabled(false);
        showToast(error, "error");
      });
  };

  return forgotStep === 1 ? (
    <div className="signup-2-section authentication">
      <BackBtn />

      <div className="form">
        <h4 className="heading-4">Enter Email For Forgot Password</h4>
        <div className=" align-items-center justify-content-between">
          <Form.Group className="mb-3">
            <Form.Control
              type="email"
              placeholder="Email Address"
              value={emailAddress}
              onInput={(e) => setEmailAddress(e.target.value)}
            />
          </Form.Group>
        </div>
        <button
          type="button"
          className="btn-primary z-2 position-relative btn btn-primary"
          onClick={clickedForgotPasswordButton}
          disabled={isDisabled}
        >
          <span>Send Verification Code</span>
          <img className="loading-icon" src={loading} alt="" />
        </button>
      </div>
    </div>
  ) : (
    <div className="signup-2-section authentication">
      <BackBtn backButtonPress={() => setForgotStep(1)} />

      <div className="form">
        <h4 className="heading-4">
          Enter the Verification Code you have Received on your Email
        </h4>
        <div className="d-flex align-items-center justify-content-between">
          {verificationCode.map((value, index) => (
            <Form.Group
              key={index}
              className="verification-code-each-input input-field no-spinner"
            >
              <Form.Control
                type="text"
                id={`code-input-${index}`}
                value={value}
                onChange={(e) => handleInputChange(index, e.target.value)}
                onPaste={(e) => handlePaste(index, e)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                inputMode="text" // Use text input mode
                maxLength={1} // Restrict to one character
                className="text-center" // Center align the input content
              />
            </Form.Group>
          ))}
        </div>
        <p
          className="resend-code paragraph-small-regular mb-3 resend-button"
          disabled={isDisabled}
        >
          <div onClick={clickedResendCodeButton}>Resend Code</div>
        </p>
        <div className=" align-items-center justify-content-between">
          <Form.Group className="mb-3">
            <Form.Control
              type="password"
              placeholder="Enter New Password"
              value={password}
              onInput={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
        </div>
        <button
          type="button"
          className="btn-primary z-2 position-relative btn btn-primary"
          onClick={clickedConfirmationCodeButton}
          disabled={isDisabled}
        >
          <span>Reset Your Password</span>
          <img className="loading-icon" src={loading} alt="" />
        </button>
      </div>
    </div>
  );
};

export default Forgot;
